module.exports = __webpack_public_path__ + "img/S-WEB-Goal-08.23671e3d.png";